export const FETCH_CONTENT = 'app/ControlFrameworkContentLibrary/FETCH_CONTENT'
export const SET_CONTENT = 'app/ControlFrameworkContentLibrary/SET_CONTENT'
export const CLEAR_CONTENT = 'app/ControlFrameworkContentLibrary/CLEAR_CONTENT'
export const SET_ACTIVE_FRAMEWORK =
  'app/ControlFrameworkContentLibrary/SET_ACTIVE_FRAMEWORK'
